import { produce } from 'immer'
import PropTypes from 'prop-types'
import { useReducer } from 'react'

import { State, DialogCurrentJobContext, DispatchDialogContext } from './useDialog'

const defaultState: State = {
  jobs: [],
  preJob: null,
}

const reducer = (state: State, action: any) => {
  const newst = produce(state, (draft) => {
    const { type, payload } = action
    switch (type) {
      case 'pushBack':
        draft.jobs.push(payload)
        break
      case 'popFront':
        draft.preJob = draft.jobs[0]
        draft.jobs = draft.jobs.slice(1)
        break
      default:
    }
  })
  return newst
}

const DialogProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultState)

  const { jobs, preJob } = state
  const currentJob = jobs[0]

  return (
    <DispatchDialogContext.Provider value={dispatch}>
      <DialogCurrentJobContext.Provider value={{ currentJob, preJob }}>
        {children}
      </DialogCurrentJobContext.Provider>
    </DispatchDialogContext.Provider>
  )
}

export default DialogProvider

DialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
